import { useMemo } from 'react';
import { OptionType } from 'components/CustomSelect/types';
import { useWaterfallContext } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext';
import { getFirmWaterfallCompanies } from './CompanyList.utils';

const useCompanyListOptions = () => {
  const { companyList } = useWaterfallContext();

  const options = useMemo<OptionType[]>(() => {
    const waterfallCompanies = getFirmWaterfallCompanies(companyList);
    if (!waterfallCompanies) {
      return [];
    }
    return waterfallCompanies.map(company => ({
      label: company.company_name ?? '',
      value: company.company_id?.toString() ?? '',
    }));
  }, [companyList]);

  return { options };
};

export default useCompanyListOptions;
